import { render, staticRenderFns } from "./CategoryTiles.vue?vue&type=template&id=08366eb8&scoped=true&"
import script from "./CategoryTiles.vue?vue&type=script&lang=js&"
export * from "./CategoryTiles.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTiles.vue?vue&type=style&index=0&id=08366eb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08366eb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
